"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustryIdPathParamsSchema = void 0;
const zod_1 = require("zod");
exports.IndustryIdPathParamsSchema = zod_1.z.object({ industryId: zod_1.z.string() });
